import { createClient } from "@supabase/supabase-js";

// Lecture des variables PUBLIQUES injectées par Vite (préfixe VITE_).
// La clé anon est faite pour le navigateur : l'accès aux données reste verrouillé
// par les politiques RLS définies dans les migrations Supabase.
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  console.error(
    "Config Supabase manquante : renseigne VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY dans .env.local"
  );
}

/* ----------------------------------------------------------------------------
   « Se souvenir de moi »
   Adaptateur de stockage qui route la session vers localStorage (persistant)
   ou sessionStorage (effacé à la fermeture de l'onglet) selon la préférence.
   La préférence elle-même est mémorisée dans localStorage pour survivre aux
   rechargements. setRememberMe() est appelé par l'UI avant la connexion.
   -------------------------------------------------------------------------- */
const REMEMBER_KEY = "st_remember";

export function setRememberMe(remember) {
  try { localStorage.setItem(REMEMBER_KEY, remember ? "1" : "0"); } catch (_) { /* ignore */ }
}
function rememberMe() {
  try { return localStorage.getItem(REMEMBER_KEY) !== "0"; } catch (_) { return true; }
}

const rememberAwareStorage = {
  getItem(key) {
    try { return localStorage.getItem(key) ?? sessionStorage.getItem(key); }
    catch (_) { return null; }
  },
  setItem(key, value) {
    try {
      if (rememberMe()) { localStorage.setItem(key, value); sessionStorage.removeItem(key); }
      else { sessionStorage.setItem(key, value); localStorage.removeItem(key); }
    } catch (_) { /* ignore */ }
  },
  removeItem(key) {
    try { localStorage.removeItem(key); sessionStorage.removeItem(key); }
    catch (_) { /* ignore */ }
  },
};

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: rememberAwareStorage,
  },
});
